import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addNewCategory } from '../../../../store/api';
import { editMenu } from '../../../../store/Menu/api';

export const useAddNewCategory = ({ slug }) => {
    const queryClient = useQueryClient();

    return useMutation(['editCurrentMenu'], ({ name, menu_id }) => addNewCategory({ name, menu_id }), {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['menu-categories', slug]);
            await queryClient.invalidateQueries(['dish-input-options', slug]);
        },
    });
};
